export const LEGACY_PORTAL_URL = process.env.REACT_APP_LEGACY_PORTAL_URL
  ? `${process.env.REACT_APP_LEGACY_PORTAL_URL}logout`
  : 'https://my.aptivepestcontrol.com/logout';
